export class Locale {
  id: string;
  displayName: string;

  constructor(id: string, displayName: string) {
    this.id = id;
    this.displayName = displayName;
  }

  toString(): string {
    return `${this.id}`;
  }
}
